import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class EmbeddedService {
  get isEmbedded(): boolean {
    const host = location.host
    const domains = [
      'qa.med-metrix.com',
      'home.med-metrix.com',
      'beta.med-metrix.com',
      'localhost:4300',
    ]

    return domains.includes(host)
  }
}
